import type { ContactValidationStatus } from '@/types/report-types';

export type ContactEmailValidationStatus = ContactValidationStatus | 'pending';

export type ContactEmailValidationEntry = {
  email: string;
  status: ContactEmailValidationStatus;
  detail?: string;
  validatedAt?: string;
};

export type ContactEmailValidationMap = Record<string, ContactEmailValidationEntry>;

export const MIN_CONTACT_EMAIL_VALIDATION_CONCURRENCY = 5;

const toPositiveInteger = (value: string | number | undefined, fallback: number) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return fallback;
  }
  return Math.max(1, Math.floor(parsed));
};

export const getContactEmailValidationConcurrency = (value?: string | number): number =>
  Math.max(
    MIN_CONTACT_EMAIL_VALIDATION_CONCURRENCY,
    toPositiveInteger(value, MIN_CONTACT_EMAIL_VALIDATION_CONCURRENCY)
  );

export const normalizeEmailForValidation = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim().toLowerCase();
  if (!normalized || !normalized.includes('@')) {
    return null;
  }
  return normalized;
};

export const collectUniqueEmailsForValidation = (values: Array<unknown>): string[] =>
  Array.from(
    new Set(
      values
        .map((value) => normalizeEmailForValidation(value))
        .filter((value): value is string => Boolean(value))
    )
  );
